import type { IconSvgObject } from './types';

const PentagonIcon: IconSvgObject = [
  ["path", { d: "M13.249 2.99967L20.9101 9.12897C21.5643 9.65235 21.8229 10.528 21.5582 11.3228L18.4569 20.6321C18.1847 21.449 17.4204 22 16.5594 22H7.4427C6.58184 22 5.81756 21.4491 5.54533 20.6325L2.44214 11.3229C2.17719 10.528 2.43577 9.65227 3.08999 9.1288L10.75 2.99973C11.4805 2.41527 12.5185 2.41524 13.249 2.99967Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }]
];

export default PentagonIcon;
